import Container from "@/components/Container";
import Header from "@/components/Header";
import Spinner from "@/components/Spinner";
import { Card, CardContent } from "@/components/ui/card";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import useEmployeeById from "@/hooks/employee/useEmployeeById";
import { getStatusColor } from "@/pages/collector/collectorList/filters/StatusDropdown";
import { useState } from "react";
import { useParams } from "react-router-dom";

function EmployeeDetails() {
    const { id } = useParams();
    const [searchTerm, setSearchTerm] = useState("");
    const {
        employee,
        transactions,
        collection,
        loading,
    } = useEmployeeById(id as string);

    const [stats, setStats] = useState<string>('dailyStats');
    console.log("employee :", employee)
    console.log("collection :", collection)
    console.log("transactions :", transactions)
    if (loading) {
        return (
            <Container>
                <div className='h-screen flex items-center justify-center'>
                    <Spinner />
                </div>
            </Container>
        );
    }
    let result: any;
    collection && Object.keys(collection).forEach(
        (key) => {

            const value = (collection as any)[key].reduce((acc: any, item: any) => {
                // Use the status as the key and _count._all as the value
                acc[item.status] = item._count._all;
                return acc;
            }, {});
            result = { ...result, [key]: value };
        }
    );
    console.log("result :", result)

    const actions = [
        { collector: 'Amine', company: 'Hilal', time: '13:09/12.03.2024', status: 'Awaiting Collection' },
        { collector: 'Amine', company: 'Ramy', time: '10:39/12.03.2024', status: 'Awaiting Collection' },
        { collector: 'Amine', company: 'POP', time: '09:10/12.03.2024', status: 'Collection in Progress' },
        { collector: 'Amine', company: 'HUM', time: '08:00/12.03.2024', status: 'Payment Collected' },
        { collector: 'Amine', company: 'HUM', time: '08:00/12.03.2024', status: 'Payment Collected' },
        { collector: 'Amine', company: 'HUM', time: '08:00/12.03.2024', status: 'Payment Collected' },
    ]
    return (
        <Container>
            <Header
                isSearchable
                placeholder='Search'
                setSearchTerm={setSearchTerm}
            />
            <div className="p-6 space-y-6 bg-[#F8F7FF] min-h-screen">
                <div className="space-y-2">
                    <h1 className="text-2xl font-semibold">Employee dashboard</h1>
                    <p>
                        {employee?.fullname} current amount: <span className="text-pink-600 font-semibold">{employee?.collectedAmount.toFixed(2)} DZD</span>
                    </p>
                </div>

                <div className="flex flex-col gap-6">
                    <div className="space-y-4 col-span-1">
                        <div className="flex justify-between items-center">
                            <h2 className="font-semibold">Collection insights</h2>
                            <Select onValueChange={setStats} defaultValue="dailyStats">
                                <SelectTrigger className="w-24 border-none bg-transparent text-[#979797] font-medium hover:bg-transparent focus:ring-0 focus:ring-offset-0 p-0">
                                    <SelectValue placeholder="Period" />
                                </SelectTrigger>
                                <SelectContent>
                                    <SelectItem value="dailyStats">Daily</SelectItem>
                                    <SelectItem value="weeklyStats">Weekly</SelectItem>
                                    <SelectItem value="monthlyStats">Monthly</SelectItem>
                                </SelectContent>
                            </Select>
                        </div>
                        <Card className="bg-green-50 border-0">
                            <CardContent className="p-4 space-y-3">
                                <div className="font-semibold text-gray-600">Deposited</div>
                                <div className="text-3xl font-bold text-green-500">{result[stats]['Payment Deposited'] || 0}</div>
                            </CardContent>
                        </Card>
                        <Card className="bg-red-50 border-0">
                            <CardContent className="p-4 space-y-3">
                                <div className="font-semibold text-gray-600">Awaiting Collection</div>
                                <div className="text-3xl font-bold text-red-500">{result[stats]['Awaiting Collection'] || 0}</div>
                            </CardContent>
                        </Card>
                        <Card className="bg-yellow-50 border-0 shadow-none">
                            <CardContent className="p-4 space-y-3">
                                <div className="font-semibold  text-gray-600">Payment Collected</div>
                                <div className="text-3xl font-bold text-yellow-500">{result[stats]['Payment Collected'] || 0}</div>
                            </CardContent>
                        </Card>
                    </div>

                    <div className="bg-white rounded-lg p-4">
                        <h2 className="font-semibold mb-4">Latest actions</h2>
                        <Table>
                            <TableHeader>
                                <TableRow>
                                    <TableHead>Collector</TableHead>
                                    <TableHead>Company</TableHead>
                                    <TableHead>Client</TableHead>
                                    <TableHead>Created at</TableHead>
                                </TableRow>
                            </TableHeader>
                            <TableBody>
                                {transactions && transactions.slice(-5).map((action, index) => (
                                    <TableRow key={index}>
                                        <TableCell className="font-medium">{employee?.fullname}</TableCell>
                                        <TableCell className="font-medium">{action.Customer.company}</TableCell>
                                        <TableCell className="font-medium">{action.Customer.fullname}</TableCell>

                                        <TableCell className="font-medium">{new Date(action.createdAt).toLocaleString()}</TableCell>
                                        <TableCell>
                                            <p
                                                className="font-medium"
                                                style={{ color: getStatusColor(action.status) }}
                                            >
                                                {action.status}
                                            </p>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </div>
                </div>
            </div>
        </Container>
    )
}

export default EmployeeDetails